// Expects an i18n string, variable to find in the string, and value to replace the variable with
// Example: ("Add {item}", "item", "Products") would result in "Add Products"
export default function (i18nString: string, variableName: string, variableValue: string) {
  return i18nString.replace(new RegExp('{' + variableName + '}', 'g'), variableValue)
}
